export default __webpack_public_path__ + "static/media/sub-app-easy-sign-pic.b22c56ffc9a3e21bf6c2022b12ec0a0c.jpg";